import React from 'react';
import Skeleton from '@mui/material/Skeleton';

function RelationsSkeleton() {
  return <Skeleton height={96} variant="rounded" sx={{ mb: 2 }} />;
}

export default RelationsSkeleton;
